// Confetti burst from "Tracking Result.dc.html" (shown once a delivery completes).
// Draws on a full-screen canvas for 4.6 s, then removes it. Returns a cleanup function.
const COLORS = ["#7130F0", "#9B6BFF", "#C9B6FF", "#A9C7FF", "#5B8DEF", "#FFC94D", "#FF9EBB"];
const DURATION = 4600;

export const launchConfetti = () => {
  if (typeof window === "undefined") return () => {};
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return () => {};

  const canvas = document.createElement("canvas");
  canvas.setAttribute("aria-hidden", "true");
  canvas.style.cssText = "position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:9999";
  document.body.appendChild(canvas);

  const dpr = Math.min(2, window.devicePixelRatio || 1);
  const W = window.innerWidth;
  const H = window.innerHeight;
  canvas.width = W * dpr;
  canvas.height = H * dpr;
  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);

  const count = Math.round(Math.min(220, W / 5 + 60));
  const pieces = Array.from({ length: count }, (_, i) => ({
    x: Math.random() * W,
    y: -10 - Math.random() * H * 0.45,
    vx: (Math.random() - 0.5) * 1.4,
    vy: 1.6 + Math.random() * 2.4,
    s: 5 + Math.random() * 7,
    r: Math.random() * 6.28,
    vr: (Math.random() - 0.5) * 0.22,
    ph: Math.random() * 6.28,
    col: COLORS[i % COLORS.length],
    dot: Math.random() < 0.28,
  }));

  let raf = 0;
  let done = false;
  const stop = () => {
    if (done) return;
    done = true;
    cancelAnimationFrame(raf);
    canvas.remove();
  };

  const start = performance.now();
  const tick = (t) => {
    const e = t - start;
    ctx.clearRect(0, 0, W, H);
    ctx.globalAlpha = e > DURATION - 1000 ? Math.max(0, (DURATION - e) / 1000) : 1;
    pieces.forEach((p) => {
      p.vy = Math.min(p.vy + 0.04, 4);
      p.x += p.vx + Math.sin(e / 380 + p.ph) * 0.8;
      p.y += p.vy;
      p.r += p.vr;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.r);
      ctx.fillStyle = p.col;
      if (p.dot) {
        ctx.beginPath();
        ctx.arc(0, 0, p.s * 0.36, 0, 6.28);
        ctx.fill();
      } else {
        ctx.scale(1, Math.cos(e / 200 + p.ph));
        ctx.fillRect(-p.s / 2, -p.s * 0.3, p.s, p.s * 0.6);
      }
      ctx.restore();
    });
    if (e < DURATION) raf = requestAnimationFrame(tick);
    else stop();
  };
  raf = requestAnimationFrame(tick);
  return stop;
};
